// extracted by mini-css-extract-plugin
export default {"AddedIngredients":"AddedIngredients_AddedIngredients__3QMHw"};